import script from "./index-one.vue?vue&type=script&setup=true&lang=js"
export * from "./index-one.vue?vue&type=script&setup=true&lang=js"

import "./index-one.vue?vue&type=style&index=0&id=f58785e4&lang=css"

const __exports__ = script;

export default __exports__